import classes from './CheckoutSuccessPage.module.css';
import Section from '../../../layouts/showcaseLayouts/Section/Section';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';

const feedSuccessPage: React.FC = () => {
  return (
    <Section>
      <SectionBody>
        <div className={classes['checkout-success']}>
          <span className={classes.title}>Здравствуйте! Благодарим за Вашу покупку!</span>
          <span className={classes.subtitle}>Мы сделали свой интернет магазин, чтобы покупки для Вас стали еще более выгодными.</span>
          <span className={classes.subtitle}>Маркетплейсы не позволяют делать выгодные цены на недорогие товары по причине высоких комиссий.</span>
          <span className={classes.subtitle}>Здесь же мы сделали для Вас самые выгодные цены. Заказы принимаем от 1000р.</span>
          <span className={classes.subtitle}>Доставка в любой регион до пункта выдачи СДЕК, Яндекс или Почты России.</span>
          <span className={classes.subtitle}>Товары будут упаковываться более тчательно в индивидуальную коробку. Отправка пока только 1 раз в неделю.</span>
          <span className={classes.subtitle}>Можете перейти на <a href={'http://kalibri.shop'}> Главную страницу</a> и начать покупки или <a href={'https://t.me/Neiro_Cat'}>связаться</a> с нами.</span>
        </div>
      </SectionBody>
    </Section>
  );
};

export default feedSuccessPage;